export default __webpack_public_path__ + "static/media/banner.20c03a87.jpg";